/**
 * useActiveMenuLayout — query GET /api/menu/layouts/active (ADR-0031).
 *
 * Używane przez:
 *   - `Sidebar` (tenant scope) — fallback B.1 gdy layout.hierarchy.length=0.
 *   - `MenuBuilderPage` — initial hierarchy do edycji.
 *
 * staleTime 60s (zgodnie z default QueryClient). User zobaczy zmiany admina
 * przy next nawigacji albo manualnym refresh.
 */

import type { MenuLayoutDto } from '@saas/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export const ACTIVE_MENU_LAYOUT_QUERY_KEY = ['tenant', 'menu', 'layouts', 'active'] as const;

export interface ActiveMenuLayoutResponse {
  layout: MenuLayoutDto | null;
}

export function useActiveMenuLayout(opts?: { enabled?: boolean }) {
  return useQuery<ActiveMenuLayoutResponse>({
    queryKey: ACTIVE_MENU_LAYOUT_QUERY_KEY,
    queryFn: async () => {
      const res = await api.get<ActiveMenuLayoutResponse>('/menu/layouts/active');
      return res.data;
    },
    enabled: opts?.enabled ?? true,
    staleTime: 60_000,
  });
}
